import React, { SFC, useState } from "react";
import { useLingui } from "@lingui/react";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import { HelpCategory, HelpItem } from "./types";
import { HelpMenu } from "./HelpMenu";
import "./helpDialog.css";

export interface Props {
  onClose: () => void;
  defaultSelectedCategoryIndex?: number;
  defaultSelectedItemInCategoryIndex?: number;
}

export const HelpDialog: SFC<Props> = ({
  onClose,
  defaultSelectedCategoryIndex = 0,
  defaultSelectedItemInCategoryIndex = 0,
}) => {
  const {
    i18n: { locale },
  } = useLingui();
  const company = useWhiteLabelSetting("name");
  const [helpText, setHelpText] = useState<{ categories: HelpCategory[] }>();
  const [activeItem, setActiveItem] = useState<HelpItem>();

  React.useEffect(() => {
    const fn = async () => {
      const help = await require(`../../../assets/${company}/help_${locale}.json`);
      setHelpText(help);
      setActiveItem(help.categories[defaultSelectedCategoryIndex].items[defaultSelectedItemInCategoryIndex]);
    };
    fn();
  }, [company, locale, setHelpText, setActiveItem, defaultSelectedCategoryIndex, defaultSelectedItemInCategoryIndex]);

  return (
    <div id="help">
      <button id="helpclose" onClick={onClose}>
        X
      </button>
      {helpText && <HelpMenu helpCategories={helpText.categories} onChange={setActiveItem} activeItem={activeItem} />}
      {activeItem && (
        <div
          id="helpmain"
          dangerouslySetInnerHTML={{
            __html: activeItem.description,
          }}
        ></div>
      )}
    </div>
  );
};

HelpDialog.displayName = "HelpDialog";
